@if(!isMobileScreen()){
  <div >
    <div mat-card-title>Highest 5 Selling items</div>
    <div class="mt-2 p-1">
      <nz-table #nzTable [nzData]="heightSelling" nzTableLayout="fixed" nzBordered nzShowPagination="false"
        nzShowSizeChanger nzOuterBordered>
        <thead>
          <tr>
            <th class="text-center">Item</th>
            <th class="text-center">Count</th>
            <th class="text-center">Revenue</th>
            <th class="text-center">% from Total Orders</th>
            <th class="text-center">% from Total Revenue</th>
          </tr>
        </thead>
        <tbody>
          @for (data of nzTable.data; track data) {
            <tr>
              <td>{{data.foodId| foodItemName : foodItems}}</td>
              <td class="text-center">{{data.quantity|number}}</td>
              <td class="text-center">{{data.totalRevenue|number}}</td>
              <td class="text-center">{{data.percentageFromTotalOrders|number}}</td>
              <td class="text-center">{{data.percentageFromTotalRevenue|number}}</td>
            </tr>
          }
        </tbody>
      </nz-table>
    </div>
  </div>}
  @else{<div>
  <div mat-card-title>Highest 5 Selling items</div>
  @for (data of heightSelling; track data) {
    <div class="col-12 mb-2 mt-2">
      <div class="card" style="box-shadow: 0 4px 2px 0 rgba(0, 0, 0, 0.25) ; border-left: 5px solid blue">
        <div class="card-body">
          <div>
            <div class="row mb-3">
              <div class="col-6 text-center">
                <div>Item</div>
                <div>{{data.foodId | foodItemName : foodItems}}</div>
              </div>
              <div class="col-3 text-center">
                <div>Count</div>
                <div class="mt-2 text-weight">{{data.quantity | number}}</div>
              </div>
              <div class="col-3 text-center">
                <div>Revenue</div>
                <div class="mt-2 text-weight">{{data.totalRevenue | number}}</div>
              </div>
            </div>
            <hr class="p-0 m-0">
            <div class="row mt-2">
              <div class="col-6 text-center">
                <div>% from Total Orders</div>
                <div class="mt-2 text-weight">{{data.percentageFromTotalOrders | number}}</div>
              </div>
              <div class="col-6 text-center">
                <div>% from Total Revenue</div>
                <div class="mt-2 text-weight">{{data.percentageFromTotalRevenue | number}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
}
